export default __webpack_public_path__ + "static/media/newsletter-p.bef91565.webp";